import React from "react";
import arrowIcon from "../../assets/arrow.svg";
import InfoSection from "./InfoSection";

const FeatureDisplay = ({ infoSectionData, data, hasArrow }) => {
  return (
    <div className="max-w-1200 mx-auto w-full">
      <div className="px-4 sm:px-6 lg:px-0">
        <div className="flex flex-col gap-8">
          <InfoSection
            subtitle={infoSectionData.subtitle || ''}
            description={infoSectionData.description || ''}
            width={infoSectionData.width || ''}
            gap={infoSectionData.gap || ''}
            descriptionClass={infoSectionData.descriptionClass || ''}
            descriptionHidden={infoSectionData.descriptionHidden || ''}
            descriptionhead={infoSectionData.descriptionhead || ''}
          />
          <div className="flex flex-col font-poppins">
            {data.map((item, idx) => {
              return (
                <div
                  id={item.id}
                  key={item.head}
                  className={`flex ${
                    idx % 2 === 0
                      ? "lg:flex-row-reverse flex-col-reverse"
                      : "lg:flex-row flex-col-reverse"
                  } lg:items-center gap-[32px] max-sm:first:mt-0 mt-[32px] md:mt-[64px]`}
                >
                  <div className={`flex ${idx % 2 === 0 ? "ml-auto" : "mr-auto"} md:min-w-[411px] md:max-w-[411px] max-lg:mx-auto sm:min-h-[260px]`}>
                    <img
                      src={item.icon}
                      alt={item.icon}
                      width={363}
                      height={364}
                      className="object-cover self-center"
                    />
                  </div>
                  <div
                    className={`flex ${
                      idx % 2 === 0 ? "items-end text-right" : "items-start"
                    } flex-col gap-2`}
                  >
                    <div className="text-darkGray font-bold text-xl">
                      {item.head}
                    </div>
                    <div
                      className={`text-darkGray/70 font-normal text-sm leading-7 max-w-[551px] lg:max-w-[687px] ${
                        idx === data.length - 1 ? "w-full" : "md:w-11/12"
                      } ${
                        idx % 2 === 0
                          ? "text-right md:pl-5"
                          : "text-left"
                      } `}
                    >
                      {item.description}
                    </div>
                    {item.points && (
                      <div>
                        <ul className="list-disc pl-6 space-y-2">
                          {item.points.map((point) => (
                            <li
                              key={point}
                              className={`text-left text-darkGray/70 marker:text-[#67DC7A] marker:text-2xl marker:leading-6 font-medium text-sm leading-7`}
                            >
                              {point}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                    {hasArrow && (
                      <div className="flex items-center gap-2 mt-2 cursor-pointer">
                        <div className="text-darkPurple font-semibold text-sm leading-7">
                          Learn More
                        </div>
                        <img
                          src={arrowIcon}
                          height={16}
                          width={16}
                          alt="arrow"
                        />
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureDisplay;
